import DesktopNav from "./DesktopNav";
import MobileNav from "./MobileNav";

function Navigation() {
    return (
        <>
          <div className="hidden md:block">
            <DesktopNav />
          </div>
      
          <div className="block md:hidden">
            <MobileNav />
          </div>
        </>
      );
}

export default Navigation;